import { render, staticRenderFns } from "./BuyingPrice.vue?vue&type=template&id=543e1f8c&scoped=true&"
import script from "./BuyingPrice.vue?vue&type=script&lang=js&"
export * from "./BuyingPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543e1f8c",
  null
  
)

export default component.exports